
import axios from 'axios';
import { useContext, useEffect, useState } from 'react'
import { Modal } from 'semantic-ui-react';
import { SettingsContext } from '../context';
import AccordionItem from './AccordionItem';



function SsaoParameters() {

    const { editorProductInfo, authenticationToken } = useContext(SettingsContext);
    let modelViewer = document.getElementById("modelViewer");

    const [notification, setNotification] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [ssaoParameters, setSsaoParameters] = useState({});



    useEffect(() => {

        getParameters();
    }, [])


    function getParameters() {

        if (!modelViewer)
            return;

        let ssaoParameters = modelViewer.getAttribute("ssaopass");
        let saoPassJson = createSaoPassJsonData(ssaoParameters);

        if (!saoPassJson)
            return;

        Object.keys(saoPassJson).forEach(function (key) {
            console.log(key, saoPassJson[key]);
        });
        setSsaoParameters(saoPassJson);
    }


    function createSaoPassJsonData(saoParams) {

        if (saoParams == "" || saoParams == null)
            return;

        let values = saoParams.split(";");
        let params = {};

        values.forEach((element, index) => {

            let value = element.split(":");
            let key = value[0];
            let keyValue = value[1];
            params[key] = keyValue;

        });

        return params;

    }


    function handleSsaoParameters(e, key) {

        let parameters = ssaoParameters;
        let oldParams = key + ":" + parameters[key];
        let newValue = e?.target?.value;
        parameters[key] = newValue;


        if (!oldParams && !newValue && newValue == "")
            return;

        let newParams = key + ":" + newValue;
        let ssaoParams = modelViewer.getAttribute("ssaopass");

        let newSsaoParams = ssaoParams.replace(oldParams, newParams);
        modelViewer?.setAttribute("ssaopass", newSsaoParams);
        console.log("newSsaoParams", newSsaoParams);

        setSsaoParameters(parameters);
    }




    function updateProductParameters(e) {

        if (!editorProductInfo)
            return;


        let ssaoParametersString = modelViewer.getAttribute("ssaopass");
        let productParametersInfo = {
            productId: editorProductInfo.id,
            parameterKey: "ssaopass",
            parameterValue: ssaoParametersString
        }
        setNotification("Güncelleniyor")
        setModalOpen(true);
        axios.post(
            process.env.REACT_APP_BACKEND_API + `products/2/update/parameters`,
            productParametersInfo,
            {
                headers: {
                    Authorization: authenticationToken
                },
            })
            .then((res) => {
                setNotification("Parameters Güncellendi.")
                setTimeout(() => {
                    setModalOpen(false);
                    setNotification(null)
                }, 2000);
            }, (rej) => {
                setNotification("Parameters Güncellenemedi.")
                setTimeout(() => {
                    setModalOpen(false);
                    setNotification(null)
                }, 5000);
            }
            );
    }


    return (
        <div>
            <AccordionItem header="SsaoParameters">

                <div style={{ height: "auto", display: "flex", gap: "1em", color: "white", flexDirection: "column", alignItems: "self-start" }} >
                    {Object.keys(ssaoParameters).map((key, index) => {

                        return (

                            <div key={index} >

                                <label>{key}</label>

                                <br></br>

                                <input defaultValue={ssaoParameters[key]} onChange={(e) => { handleSsaoParameters(e, key) }} />


                            </div>
                        );

                    })}
                </div>

                <button className='saveButton' onClick={(e) => { updateProductParameters() }}>Update</button>

            </AccordionItem >


            <Modal
                onOpen={() => setModalOpen(true)}
                onClose={() => setModalOpen(false)}
                open={modalOpen}
                className="commentRepModal"
                dimmer="blurring"
                size="small"
                closeOnDimmerClick={false}
            >
                <Modal.Content>
                    <div className="loadingModal">
                        <div className="lds-default">
                            <p>{notification}</p>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>


        </div >

    );
}
export default SsaoParameters;

